// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Card_cardContainer__3qb8Q","cards":"Card_cards__2y3Qd","CardDetailComponent":"Card_CardDetailComponent__69uNg"};